<template>
  <TableGradient
      icon-name="flask"
      :title="$t('tuevs.exams.listagem.titulo_pagina')"
      :items="exams"
      :paginator="pagination"
      :fields="table_fields"
      :loading="isLoading"
      :text-empty="$t('tuevs.exams.listagem.table.empty')"
      table-data
      selectable
      @list="listItems"
      @select="evt => { selected = evt }">
    <template v-slot:headerRight>
      <b-btn id="btn-criar" variant="outline-info" @click="showModal('create')">
        <i class="fas fa-plus"/> {{ $t('tuevs.exams.listagem.bulk.inserir') }}
      </b-btn>
    </template>
    <template v-slot:select-text>
      <b-button variant="link" class="p-0 m-0" @click="showModal('edit')"
                :title="$t('tuevs.exams.listagem.table.editar')" v-b-tooltip.hover>
        <i class="fas fa-edit"/></b-button>
    </template>

    <template v-slot:cell(component)="linha">
      {{ linha.item.component ? linha.item.component.name : null }}
    </template>
    <template v-slot:cell(method)="linha">
      {{ linha.item.method ? linha.item.method.name : null }}
    </template>
    <template v-slot:cell(scale)="linha">
      {{ linha.item.scale ? linha.item.scale.name : null }}
    </template>
    <template v-slot:cell(specimen)="linha">
      {{ linha.item.specimen ? linha.item.specimen.name : null }}
    </template>
    <template v-slot:cell(time)="linha">
      {{ linha.item.time ? linha.item.time.name : null }}
    </template>
    <template v-slot:cell(status)="linha">
            <span
                :class="{'rounded-pill p-1 badge':true, 'badge-success':linha.item.status, 'badge-danger': !linha.item.status}">
                <em v-if="linha.item.status">{{ $t('tuevs.exams.listagem.habilitado') }}</em>
                <em v-else>{{ $t('tuevs.exams.listagem.desabilitado') }}</em>
            </span>
    </template>

    <template v-slot:LayoutGradientAppend>
      <b-modal id="modal-bulk" title="Bulk Change" :size="modalSize" hide-footer>
        <BulkForm :selected="selected" :fields="form_fields" @persist="submit">
          <template v-slot:field(status)="{id, enabled, model}">
            <b-form-checkbox :id="id" v-model="model.status" size="lg" :disabled="!enabled" switch/>
          </template>
          <template v-slot:field(orderObservation)="{id, enabled, model}">
            <SelectComponent id="input-orderObservation" :options="directions" :disabled="!enabled"
                             @input="evt => {model.orderObservation = evt}"/>
          </template>
          <template v-slot:field(tuevs_component_id)="{id, enabled, model}">
            <SelectTuevsComponent :id="id" :disabled="!enabled"
                                  @input="evt => {model.tuevs_component_id = evt}"/>
          </template>
          <template v-slot:field(specimen)="{id, enabled, model}">
            <SelectTuevsMaterial :id="id" :disabled="!enabled"
                                 @input="evt => {model.specimen = evt}"/>
          </template>
          <template v-slot:field(tuevs_specimen_id)="{id, enabled, model}">
            <SelectTuevsMaterial :id="id" :disabled="!enabled"
                                 @input="evt => {model.tuevs_specimen_id = evt}"/>
          </template>
          <template v-slot:field(method)="{id, enabled, model}">
            <SelectTuevsMetodo :id="id" :disabled="!enabled"
                               @input="evt => {model.method = evt}"/>
          </template>
          <template v-slot:field(tuevs_method_id)="{id, enabled, model}">
            <SelectTuevsMetodo :id="id" :disabled="!enabled"
                               @input="evt => {model.tuevs_method_id = evt}"/>
          </template>
          <template v-slot:field(scale)="{id, enabled, model}">
            <SelectTuevsEscala :id="id" :disabled="!enabled"
                               @input="evt => {model.scale = evt}"/>
          </template>
          <template v-slot:field(time)="{id, enabled, model}">
            <SelectTuevsTempo :id="id" :disabled="!enabled" @input="evt => {model.time = evt}"/>
          </template>
          <template v-slot:field(childrens)="{id, enabled}">
            <SelectTuevsExam :id="id" :disabled="!enabled" @input="evt => addElement('childrens', evt)"/>
            <b-table thead-class="d-none" :fields="['value','label']" :items="childrens">
              <template v-slot:cell(value)="linha">
                <b-button variant="outline-danger" @click="removeElement('childrens', linha.item)" pill>
                  <i class="fas fa-minus"/></b-button>
              </template>
            </b-table>
          </template>
          <template v-slot:field(synonyms)="{id, enabled}">
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="outline-success" :disabled="!enabled"
                          @click="e => {
                                              addElement('synonyms', {value: input_sinonimo, label: input_sinonimo});
                                              input_sinonimo = ''
                                          }">
                  <i class="fas fa-plus"/></b-button>
              </b-input-group-prepend>
              <b-form-input :id="id" v-model="input_sinonimo" :disabled="!enabled"/>
            </b-input-group>
            <b-table :fields="['value','label']" :items="synonyms" thead-class="d-none">
              <template v-slot:cell(value)="linha">
                <b-button variant="outline-danger" @click="removeElement('synonyms', linha.item)" pill>
                  <i class="fas fa-minus"/></b-button>
              </template>
            </b-table>
          </template>
        </BulkForm>
      </b-modal>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import SelectTuevsComponent from "@/components/tuevs/Select/SelectTuevsComponent";
import SelectTuevsEscala from "@/components/tuevs/Select/SelectTuevsEscala";
import SelectTuevsExam from "@/components/tuevs/Select/SelectTuevsExam";
import SelectTuevsMaterial from "@/components/tuevs/Select/SelectTuevsMaterial";
import SelectTuevsMetodo from "@/components/tuevs/Select/SelectTuevsMetodo";
import SelectTuevsTempo from "@/components/tuevs/Select/SelectTuevsTempo";
import BulkForm from "@/components/Bulk/BulkForm";
import SelectComponent from "@/components/SelectComponent";
import ExamsRepository from "@/repositories/tuevs/ExamRepository";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Index",
  components: {
    SelectTuevsTempo,
    SelectTuevsExam,
    SelectTuevsEscala,
    SelectTuevsMetodo,
    SelectTuevsMaterial,
    SelectComponent,
    SelectTuevsComponent,
    BulkForm,
    TableGradient
  },
  computed: {
    ...mapGetters({
      store_isLoading: 'tuevs/exams/isLoading',
      store_exams: 'tuevs/exams/all',
      pagination: 'tuevs/exams/pagination'
    }),
    directions() {
      return [
        {label: this.$t('tuevs.exams.form.fields.directions.ordem'), value: 'order'},
        {label: this.$t('tuevs.exams.form.fields.directions.resultado'), value: 'observation'},
        {label: this.$t('tuevs.exams.form.fields.directions.ambos'), value: 'both'},
      ]
    },
    exams() {
      if (this.store_exams && Array.isArray(this.store_exams)) {
        return this.store_exams.map(e => {
          e.rowSelected = false
          if (this.selected.find(s => s.id === e.id)) {
            e.rowSelected = true
          }
          return e
        })
      }
      return []
    },
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      modalSize: 'lg',
      table_fields: [
        {key: 'name', label: this.$t('tuevs.exams.listagem.table.nome')},
        {key: 'component', label: this.$t('tuevs.exams.listagem.table.componente')},
        {key: 'method', label: this.$t('tuevs.exams.listagem.table.metodo')},
        {key: 'scale', label: this.$t('tuevs.exams.listagem.table.escala')},
        {key: 'specimen', label: this.$t('tuevs.exams.listagem.table.material')},
        {key: 'time', label: this.$t('tuevs.exams.listagem.table.tempo')},
        {key: 'status', label: 'Status'},
      ],
      form_fields: [],
      create_fields: [
        {
          key: 'status',
          label: 'Status',
          description: this.$t('tuevs.exams.form.fields.status.description')
        },
        {key: 'name', label: this.$t('tuevs.exams.form.fields.nome.label')},
        {key: 'external_code', label: this.$t('tuevs.exams.form.fields.codigo.label')},
        {key: 'tuevs_method_id', label: this.$t('tuevs.exams.form.fields.metodo.label')},
        {key: 'tuevs_specimen_id', label: this.$t('tuevs.exams.form.fields.material.label')},
        {key: 'orderObservation', label: this.$t('tuevs.exams.form.fields.ordem_resultado.label')},
        {key: 'tuevs_component_id', label: this.$t('tuevs.exams.form.fields.componente.label')},
      ],
      edit_fields: [
        {
          key: 'status',
          label: 'Status',
          description: this.$t('tuevs.exams.form.fields.status.description')
        },
        {key: 'orderObservation', label: this.$t('tuevs.exams.form.fields.ordem_resultado.label')},
        {key: 'tuevs_component_id', label: this.$t('tuevs.exams.form.fields.componente.label')},
        {key: 'specimen', label: this.$t('tuevs.exams.form.fields.material.label')},
        {key: 'method', label: this.$t('tuevs.exams.form.fields.metodo.label')},
        {key: 'scale', label: this.$t('tuevs.exams.form.fields.escala.label')},
        {key: 'time', label: this.$t('tuevs.exams.form.fields.tempo.label')},
        {key: 'mnemonic_veus_exam', label: this.$t('tuevs.exams.form.fields.mnemonico_veus_exam.label')},
        {
          key: 'mnemonic_veus_subexam',
          label: this.$t('tuevs.exams.form.fields.mnemonico_veus_subexam.label')
        },
        {key: 'childrens', label: this.$t('tuevs.exams.form.fields.adicionar_subexames')},
        {key: 'synonyms', label: this.$t('tuevs.exams.form.fields.adicionar_sinonimos')},
      ],
      selected: [],
      childrens: [],
      synonyms: [],
      input_sinonimo: ''
    }
  },
  methods: {
    ...mapActions([
      'tuevs/exams/listAll'
    ]),
    async listItems(evt) {
      console.log('evt', JSON.stringify(evt))
      const selected = this.selected
      await this.$store.commit('tuevs/exams/setAll', selected)
      await this['tuevs/exams/listAll']({...evt, aggregate: true})
      this.selected = selected
    },
    showModal(mode) {
      this.form_fields = []
      if (mode === 'create') {
        this.modalSize = 'xl'
        if (this.selected.length > 0) {
          this.$snotify.warning(this.$t('tuevs.exams.listagem.bulk.desselecionar'))
          return
        }
        this.form_fields = this.create_fields
      }
      if (mode === 'edit') {
        this.modalSize = 'md'
        if (this.selected.length === 0) {
          this.$snotify.warning(this.$t('tuevs.exams.listagem.bulk.selecione_um_item'))
          return
        }
        this.form_fields = this.edit_fields
      }

      this.$bvModal.show('modal-bulk')
    },
    addElement(array, element) {
      if (element && element.value && element.label) {
        this[array] = [...this[array], element];
      }
    },
    removeElement(array, element) {
      this[array] = this[array].filter(e => e !== element)
    },
    submit(evt) {
      if (this.selected.length > 0) {
        let params = evt
        if (evt.hasOwnProperty('childrens')) {
          const childrens = this.childrens.map(c => {
            c = (c && c.value) ? c.value : null
            return c
          })
          params = {...params, childrens}
        }
        if (evt.hasOwnProperty('synonyms')) {
          const synonyms = this.synonyms.map(s => {
            s = (s && s.value) ? s.value : null
            return s
          })
          params = {...params, synonyms}
        }
        if (evt.hasOwnProperty('status') && evt.status === null) {
          evt.status = false
        }

        ExamsRepository.bulkPut(params).then(response => {
          this.$snotify.success(this.$t('tuevs.exams.form.update.success'))
          this.selected = []
          this.listItems()
          this.$bvModal.hide('modal-bulk')
        }).catch(error => {
          this.$snotify.error(this.$t('tuevs.exams.form.update.error'))
        })
        return
      }

      ExamsRepository.bulkPost({
        quantity_record: evt.quantity_record,
        exams: evt.array
      }).then(response => {
        this.$snotify.success(this.$t('tuevs.exams.form.create.success'))
        this.selected = []
        this.listItems()
        this.$bvModal.hide('modal-bulk')
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.exams.form.create.error'))
      })
    }
  },
  mounted() {
    this['tuevs/exams/listAll']()
    this.mounted = true
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.form_fields = []
      this.childrens = []
      this.synonyms = []
      this.input_sinonimo = ''
    })
  },
}
</script>

<style lang="scss" scoped>
</style>